import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AdminAuthShell, { AuthField, AuthSubmit } from "@/components/AdminAuthShell";
import { PASSWORD_HINT } from "@/pages/AdminPasswordReset";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminChangePassword() {
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Le due nuove password non coincidono.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("admin_token");
      await axios.post(
        `${API}/admin/change-password`,
        { current_password: current, new_password: password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Il cambio password invalida tutte le sessioni, compresa questa.
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_email");
      setDone(true);
      setTimeout(() => navigate("/admin/login", { replace: true }), 2500);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Impossibile cambiare la password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminAuthShell
      testId="admin-change-password-page"
      title="Cambia password"
      intro={done ? undefined : "Per sicurezza dovrai accedere di nuovo con la nuova password."}
      error={error}
      success={done ? "Password aggiornata. Ti stiamo portando alla pagina di accesso..." : ""}
      footer={
        <Link
          to="/admin"
          className="text-slate-600 hover:text-slate-900 underline underline-offset-4"
        >
          ← Torna alle richieste
        </Link>
      }
    >
      {!done && (
        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-change-password-form">
          <AuthField
            label="Password attuale"
            type="password"
            autoFocus
            required
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            data-testid="admin-current-password-input"
          />
          <AuthField
            label="Nuova password"
            type="password"
            required
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            hint={PASSWORD_HINT}
            data-testid="admin-new-password-input"
          />
          <AuthField
            label="Conferma nuova password"
            type="password"
            required
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="admin-confirm-password-input"
          />
          <AuthSubmit
            loading={loading}
            loadingLabel="Salvataggio..."
            data-testid="admin-change-password-submit"
          >
            Cambia password
          </AuthSubmit>
        </form>
      )}
    </AdminAuthShell>
  );
}
